var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_4212)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70708 0.737438C1.51848 0.55528 1.26588 0.454485 1.00368 0.456764C0.741483 0.459042 0.490671 0.564211 0.305263 0.749619C0.119854 0.935027 0.0146856 1.18584 0.0124071 1.44804C0.0101287 1.71023 0.110923 1.96284 0.293081 2.15144L5.58608 7.44444L0.293081 12.7374C0.197571 12.8297 0.121389 12.94 0.0689798 13.062C0.0165708 13.184 -0.0110155 13.3153 -0.0121693 13.448C-0.0133231 13.5808 0.0119786 13.7125 0.0622595 13.8354C0.11254 13.9583 0.186794 14.0699 0.280686 14.1638C0.374579 14.2577 0.486231 14.332 0.609127 14.3823C0.732023 14.4325 0.863703 14.4578 0.996482 14.4567C1.12926 14.4555 1.26048 14.4279 1.38249 14.3755C1.50449 14.3231 1.61483 14.2469 1.70708 14.1514L7.00008 8.85844L12.2931 14.1514C12.4817 14.3336 12.7343 14.4344 12.9965 14.4321C13.2587 14.4298 13.5095 14.3247 13.6949 14.1393C13.8803 13.9538 13.9855 13.703 13.9878 13.4408C13.99 13.1786 13.8892 12.926 13.7071 12.7374L8.41408 7.44444L13.7071 2.15144C13.8892 1.96284 13.99 1.71023 13.9878 1.44804C13.9855 1.18584 13.8803 0.935027 13.6949 0.749619C13.5095 0.564211 13.2587 0.459042 12.9965 0.456764C12.7343 0.454485 12.4817 0.55528 12.2931 0.737438L7.00008 6.03044L1.70708 0.737438Z",
    fill: "#E02D3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_4212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.444458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.24db72b0130a3af21f620194534cbd4b.svg";
export { ForwardRef as ReactComponent };